import AirDatepicker, {AirDatepickerOptions} from 'air-datepicker'
import AirDatepickerCs from 'air-datepicker/locale/cs';
import 'air-datepicker/air-datepicker.css'

const defaultOptions : AirDatepickerOptions = {
    locale: AirDatepickerCs,
    dateFormat: 'yyyy-MM-dd',
    autoClose: true,
    toggleSelected: false,
};

let initialized : Array<HTMLElement> = [];

function isWorkday(date: Date): boolean
{
    const day = date.getDay();
    return !(day === 0 || day === 6);
}

function activateMobileIfNeeded(currentSettings: AirDatepickerOptions): AirDatepickerOptions {
    let clone = Object.assign({}, currentSettings);
    clone.isMobile = window.matchMedia(`(max-width: 768px)`).matches;
    return clone;
}

function onlyWorkdaysAllowed(currentSettings: AirDatepickerOptions): AirDatepickerOptions
{
    let clone = Object.assign({}, currentSettings);
    clone.onRenderCell = ({ date, cellType }) => {
        // Zakázat buňky pro dny, pokud je víkend
        if (cellType === 'day' && !isWorkday(date)) {
            return {
                disabled: true
            };
        }
    }

    return clone;
}

function applyMinMaxIfNeeded(currentSettings: AirDatepickerOptions, input: HTMLInputElement): AirDatepickerOptions
{
    let clone = Object.assign({}, currentSettings);
    if (input.hasAttribute('min')) {
        clone.minDate = input.getAttribute('min') + '';
    }

    if (input.hasAttribute('max')) {
        clone.maxDate = input.getAttribute('max') + '';
    }

    return clone;
}

function initAndShowPicker(input: HTMLInputElement, options: AirDatepickerOptions): void
{
    new AirDatepicker(input, options).show();
}

function initializeDate(container: HTMLElement): void
{
    const input = container.querySelector('[type="date"]') as HTMLInputElement|null;

    if (input === null) {
        console.log('DatePicker Date: input not found')
        return;
    }

    console.log('DatePicker Date: input found')
    initAndShowPicker(input, applyMinMaxIfNeeded(onlyWorkdaysAllowed(activateMobileIfNeeded(defaultOptions)), input))
}

function initializeDateRange(container: HTMLElement): void
{
    let dpMin: AirDatepicker;
    let dpMax: AirDatepicker;

    // Získání všech input prvků uvnitř kontejneru
    const inputs = container.querySelectorAll('input');

    // Ověření, že máme alespoň dva inputy
    if (inputs.length >= 2) {
        const startDateInput = inputs[0] as HTMLInputElement;
        const endDateInput = inputs[1] as HTMLInputElement;

        let dpMinSettings = applyMinMaxIfNeeded(onlyWorkdaysAllowed(activateMobileIfNeeded(defaultOptions)), startDateInput);
        dpMinSettings.onSelect = ({ date }) => {
            if (date instanceof Date && dpMax) {
                dpMax.update({
                    minDate: date.setDate(date.getDate() + 1),
                });
                if (dpMax.selectedDates.length > 0 && date > dpMax.selectedDates[0]) {
                    dpMax.clear();
                }
                dpMax.show();
            }
        };

        dpMin = new AirDatepicker(startDateInput, dpMinSettings);
        dpMin.show();

        let dpMaxSettings = applyMinMaxIfNeeded(onlyWorkdaysAllowed(activateMobileIfNeeded(defaultOptions)), endDateInput);
        dpMaxSettings.onSelect = ({date}) => {
            if (date instanceof Date && dpMin) {
                dpMin.update({
                    maxDate: date
                });
                if (dpMin.selectedDates.length > 0 && date < dpMin.selectedDates[0]) {
                    dpMin.clear();
                }
            }
        };

        dpMax = new AirDatepicker(endDateInput, dpMaxSettings);
    } else {
        console.error("V kontejneru bylo nalezeno méně než 2 input prvky.");
    }
}

function initialize() {
    console.log('DatePicker: Init run');

    document.addEventListener('focusin', function (event ) {
        const target = event.target as HTMLElement|null;

        if (target === null) {
            console.log('DatePicker: missing target');
            return;
        }

        console.log('DatePicker: focusInput');
        let container = target.closest('[data-datepicker]') as HTMLInputElement|null;

        if (container !== null && !initialized.includes(container)) {
            console.log('DatePicker: container found');
            const datepickerType: string = container.dataset.datepicker || '';

            if (datepickerType === 'date') {
                console.log('DatePicker: date service');
                initializeDate(container)
            } else if(datepickerType === 'dateRange') {
                console.log('DatePicker: dateRange service');
                initializeDateRange(container)
            } else {
                console.log('DatePicker: unknown service');
            }
            initialized.push(container);
        }
    });
}

document.addEventListener("DOMContentLoaded", function() {
    const cssTemplateString =
    '[data-datepicker] input[type="date"] { -moz-appearance: none; -webkit-appearance: none; appearance: none; padding-right: 30px; position: relative; }' +
    '[data-datepicker] input[type="date"]::-webkit-calendar-picker-indicator { display: none;}';
    const styleTag = document.createElement("style");
    styleTag.innerHTML = cssTemplateString;
    document.head.insertAdjacentElement('beforeend', styleTag);
    initialize();
});

